<template lang="pug">
v-menu(
  dense
  bottom
  offset-y
  :left="left"
)
  template(#activator="{ on, attrs }")
    v-btn.ml-1(
      icon
      :small="small"
      :x-small="xSmall"
      v-bind="attrs"
      v-on="on"
    )
      v-icon mdi-dots-vertical

  v-list(dense)
    slot(name='#top')

    template(v-for="(category,categoryIndex) in actions.menu.categories")
      v-subheader(v-if="category.name") {{ category.name }}

      action-bar-menu-item(
        v-for="(action,actionIndex) in category.actions"
        :key="`menu-${categoryIndex}-${actionIndex}`"
        :action="action"
        v-bind="$props"
        @perform="opts => $emit('perform', opts)"
      )

    slot

    slot(name='#bottom')
</template>

<script>
import ActionBarMenuItem from './ActionBarExMenuItem'
import ActionBarPin from './ActionBarExPin'

export default {
  components: {
    ActionBarMenuItem,
    ActionBarPin,
  },

  props: {
    /**
     * Instância da entidade atualmente em exbição.
     */
    entity: Object,
    data: Object,
    row: Object,

    /**
       * Ações disponíveis no menu.
       *
       * Esta propriedade recebe um objeto que contém a estrutura de ações organizadas no menu.
       *
       * @type {Object}
       * @property {Array} all - Todas as ações no menu.
       * @property {Array} main - Ações principais no menu.
       * @property {Array} side - Ações secundárias no menu.
       * @property {Array} rest - Outras ações no menu.
       * @property {Array} categories
       *    - Categorias personalizadas no menu, cada uma contendo um nome e um conjunto de ações.
       *
       * @example
       * {
       *   menu: {
       *     all: [...], // Todas as ações da página
       *     main: [...], // Ações principais da página
       *     side: [...], // Ações secundárias da página
       *     rest: [...], // Outras ações da página
       *     categories: [
       *       { name: 'Category1', actions: [...] }, // Categorias personalizadas
       *       { name: 'Category2', actions: [...] },
       *       // ...
       *     ]
       *   },
       *   pins: {
       *     all: [...], // Todas as ações fixadas da página
       *     main: [...], // Ações principais fixadas da página
       *     side: [...], // Ações secundárias fixadas da página
       *     rest: [...], // Outras ações fixadas da página
       *     categories: [
       *       { name: 'Category1', actions: [...] }, // Categorias personalizadas
       *       { name: 'Category2', actions: [...] },
       *       // ...
       *     ]
       *   }
       * }
       */
    actions: Object,

    title: String,
    description: String,

    context: Object,

    left: Boolean,
    small: Boolean,
    xSmall: Boolean,

    allowTitle: Boolean,
    allowClose: Boolean,
  },
}
</script>